module.exports = __webpack_public_path__ + "static/img/webmeeting.e43c537.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/template/webmeeting.png
// module id = I4cp
// module chunks = 3